function UserForms(form, callback) {
    $.ajax({
        type: form.attr("method"),
        url: form.attr("action"),
        data: form.serialize(),
        dataType: "json",
        cache: false,
        success: function (dt) {
            callback(dt);
        },
        error: function () {
            callback("Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.");
        }
    });
}

function AccountAjaxForms(form, callback) {
    $.ajax({
        type: form.attr("method"),
        url: form.attr("action"),
        data: form.serialize(),
        dataType: 'json',
        cache: false,
        success: function (data) {
            callback(data.Sonuc, data.IslemSonucAciklama);
        },
        error: function () {
            callback(false, "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.");
        }
    });
}

function MyOrderNotMember(form) {
    $.ajax({
        type: form.attr("method"),
        url: form.attr("action"),
        data: form.serialize(),
        success: function (data) {

            $("#UserOrderModal").modal("show");
            $("#UserOrderModal").find(".modal-body").html(data);

            $("iframe").css("height", $("iframe").height() + 1000);

            GenerateLocalLoading(form, "hide");
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            GenerateLocalLoading(form, "hide");
        }
    });
}

function DeleteFollowItem(ID, langID, callback) {
    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
        data: 'id=' + ID + "&langID=" + langID,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        success: function (dt) {
            callback(dt.Sonuc, dt.IslemSonucAciklama);
        },
        error: function () {
            callback(false, "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.");
        }
    });
}

// #region Orders
function GetUserOrderDetails(Url, callback) {
    $.ajax({
        type: 'GET',
        url: Url,
        cache: false,
        success: function (data) {
            callback(data);
        }
    });
}

function GetRetOrdersForm(orderedItemsID, callback) {
    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + "/p/Orders/RetOrder",
        data: 'OrderedItemID=' + orderedItemsID,
        success: function (data) {
            callback(true, data);
        },
        error: function () {
            callback(false, "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.");
        }
    });
}

function GetRetOrdersMemberlessForm(orderedItemsID, callback) {
    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + "/p/Home/RetOrderMemberless",
        data: 'OrderedItemID=' + orderedItemsID,
        success: function (data) {
            callback(true, data);
        },
        error: function () {
            callback(false, "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.");
        }
    });
}

function GetMoneyTransferInfoForm(trackCode, callback) {
    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + "/p/Orders/MoneyTransferInfo",
        data: 'TrackCode=' + trackCode,
        success: function (data) {
            callback(true, data);
        },
        error: function () {
            callback(false, "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.");
        }
    });
}
// #endregion

// #region Address
function GetAddressList() {
    GenerateLocalLoading($(".AdresFieldSet .MyAddress"), "show");

    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + '/p/User/AdressInfo',
        data: "language=" + $("#SmallLangCode").val(),
        success: function (data) {
            $(".AdresFieldSet .MyAddress").html(data);
            GenerateLocalLoading($(".AdresFieldSet .MyAddress"), "hide");
        },
        error: function () {
            GenerateLocalLoading($(".AdresFieldSet .MyAddress"), "hide");
        }
    });
}

function GetPartialAdress(AddressModal, EditLink) {
    if (EditLink == "" || EditLink == null || EditLink == undefined) {
        EditLink = "/" + $("#SmallLangCode").val() + "/p/User/PartialAdressAdd";
        AddressModal.find(".modal-header > .edit").hide();
        AddressModal.find(".modal-header > .create").show();
    }
    else {
        AddressModal.find(".modal-header > .edit").show();
        AddressModal.find(".modal-header > .create").hide();
    }

    $.ajax({
        type: "GET",
        url: EditLink,
        success: function (data) {
            AddressModal.find(".modal-body").html(data);

            // Adres formunda fatura bilgileri inputları için
            //if ($("#AdresTipi2").is(":checked")) {
            //    $(".vergi").show(); $(".tcno").hide();
            //}

            //if ($("#AdresTipi1").is(":checked")) {
            //    $(".vergi").hide(); $(".tcno").show();
            //}

            if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "TR"
                || $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "KKTC") { // TR
                $(".tr_group").show();
                $(".stateDiv").hide();
                $(".cityDiv").hide();
            }

            if (($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "TR"
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "KKTC")
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "CA"
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "US") { //Rest of world

                $(".tr_group").hide();
                $(".stateDiv").hide();
                $(".cityDiv").show();
            }

            if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "CA"
                ||
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "US") { //USA & CA

                $(".tr_group").hide();
                $(".stateDiv").show();
                $(".cityDiv").show();
            }

            PhoneFormatAccount();

            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            AddressModal.modal("hide");
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        }
    });
}


function GetCities(countryID) {
    var AddressModal = $(".address-wrapper");
    GenerateLocalLoading(AddressModal, "show");

    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + '/p/User/GetCities',
        data: 'countryid=' + countryID,
        dataType: 'json',
        success: function (dt) {
            //$('.address-wrapper #CityID option').remove();

            //$('#CityID option').remove();
            $('.ddl_sehir option').remove();
            $('.ddl_ilce option').remove();
            $('.ddl_mahalle option').remove(); // Adres kısmında mahalle bilgisi alınacaksa burası sonradan ayarlanmalıdır

            for (var i = 0; i < dt.length; i++) {
                $('.address-wrapper .ddl_sehir').append($("<option></option>").attr("value", dt[i].ID).text(dt[i].Name));
            }

            if (dt.length > 0) {
                GetDistrict(dt[0].ID); // Seçilen şehir değişince seçilen şehrin ilçelerinin çekilmesi için bu istek geçiliyor
            }

            GenerateLocalLoading(AddressModal, "hide");
        },
        error: function () {
            GenerateLocalLoading(AddressModal, "hide");
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
        }
    });
}

function GetDistrict(CityID) {
    var AddressModal = $(".address-wrapper");
    GenerateLocalLoading(AddressModal, "show");

    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + '/p/User/GetTowns',
        data: 'cityid=' + CityID,
        dataType: 'json',
        success: function (dt) {
            //$('.address-wrapper #TownID option').remove();

            $('.ddl_ilce option').remove();
            $('.ddl_mahalle option').remove();  // Adres kısmında mahalle bilgisi alınacaksa burası sonradan ayarlanmalıdır

            for (var i = 0; i < dt.length; i++) {
                $('.address-wrapper .ddl_ilce').append($("<option></option>").attr("value", dt[i].ID).text(dt[i].Name));
            }

            // Mahalle bilgisi kullanılmaya başlandığında bu kısmı aç
            if (dt.length > 0) {
                GetQuarters(dt[0].ID); // Seçilen ilçe değişince seçilen ilçenin mahallelerinin çekilmesi için bu istek geçiliyor
            }

            GenerateLocalLoading(AddressModal, "hide");
        },
        error: function () {
            GenerateLocalLoading(AddressModal, "hide");
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
        }
    });
}

function GetQuarters(townID) {
    var AddressModal = $(".address-wrapper");
    GenerateLocalLoading(AddressModal, "show");

    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + '/p/User/GetQuarters',
        data: 'townID=' + townID,
        dataType: 'json',
        success: function (dt) {
            $('.ddl_mahalle option').remove();

            $('.address-wrapper .ddl_mahalle').append($("<option></option>").attr("value", "").text("Mahalle")).prop("selected", true);
            for (var i = 0; i < dt.length; i++) {
                $('.address-wrapper .ddl_mahalle').append($("<option></option>").attr("value", dt[i].ID).text(dt[i].Name));
            }

            GenerateLocalLoading(AddressModal, "hide");
        },
        error: function () {
            GenerateLocalLoading(AddressModal, "hide");
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
        }
    });
}

//function GetDistrict(CityID) {
//    $.ajax({
//        type: 'get',
//        url: "/" + $("#SmallLangCode").val() + '/p/User/GetTowns',
//        data: 'cityid=' + CityID,
//        dataType: 'json',
//        success: function (dt) {
//            $('#district option').remove();

//            //$('#district')
//            //    .append($("<option selected='selected' ></option>")
//            //        .attr("value", "")
//            //        .text("Lütfen Seçin"));
//            //$('#district').parent().find("span").html("Lütfen Seçin");

//            for (var i = 0; i < dt.length; i++) {
//                $('#district')
//                    .append($("<option></option>")
//                        .attr("value", dt[i].ID)
//                        .text(dt[i].Name));

//            }

//            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
//        },
//        error: function () {
//            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
//            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
//        }
//    });
//}

function DeleteAddress(AddressID, AddressBox) {
    var DeleteUrl = "/" + $("#SmallLangCode").val() + "/p/User/DeleteAdress/" + AddressID;
    GenerateLocalLoading(AddressBox, "show");

    $.ajax({
        type: "POST",
        url: DeleteUrl,
        cache: false,
        success: function (data) {
            if (data == "true") {
                SwalGenerate("success", "Adres kaydı silindi.", "İşlem Başarılı", "Kapat");
                GetAddressList();
            }
            else {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            }

            GenerateLocalLoading(AddressBox, "hide");
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            GenerateLocalLoading(AddressBox, "hide");
        }
    });
}
// #endregion

// #region User Messages
function GetMessageDetail(Url) {
    var Modal = $("#MessageDetailModal");
    Modal.modal("show");
    ModalHideEvent(Modal, ".modal-content");
    GenerateLocalLoading(Modal.find(".modal-dialog"), "show");

    $.ajax({
        type: 'GET',
        url: Url,
        cache: false,
        success: function (data) {
            Modal.find(".modal-content").html(data);
            GenerateLocalLoading(Modal.find(".modal-dialog"), "hide");
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            GenerateLocalLoading(Modal.find(".modal-dialog"), "hide");
            setTimeout(function () { Modal.modal("hide"); }, 500);
        }
    });
}

function AddNewUserMessage(form, IsNewMessage) {
    $.ajax({
        type: form.attr("method"),
        url: form.attr("action"),
        data: form.serialize(),
        cache: false,
        success: function (data) {
            $("#MessageDetailModal .modal-content").html(data);

            GenerateLocalLoading(form, "hide");
            $("#MessageDetailModal").modal("hide");
            SwalGenerate("success", "Mesajınız iletilmiştir.", "İşlem Başarılı", "Kapat");

            if (IsNewMessage) {
                GenerateLocalLoading($("#UserMessages"), "show");

                $.ajax({
                    url: "/" + $("#SmallLangCode").val() + "/p/User/Messages",
                    type: "GET",
                    cache: false,
                    success: function (data) {
                        $("#UserMessages tbody").html(data);
                        GenerateLocalLoading($("#UserMessages"), "hide");
                    },
                    error: function () {
                        GenerateLocalLoading($("#UserMessages"), "hide");
                    }
                });
            }
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            GenerateLocalLoading(form, "hide");
        }
    });
}
// #endregion

// #region Card List

function DeleteUserCard(CardUserKey, CardToken) {

    //alert("CardUserKey: " + CardUserKey);

    //alert("CardToken: " + CardToken);

    if (CardToken != undefined && CardToken != null && CardUserKey != undefined && CardUserKey != null) {
        $.ajax({
            type: 'POST',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/UserCardDelete?cardUserKey=" + encodeURIComponent(CardUserKey) + "&cardToken=" + encodeURIComponent(CardToken),
            cache: false,
            async: true,
            success: function (dt) {
                ReloadOnTimeOut();

                if (dt.Status == true) {
                    SwalGenerate("success", dt.ResultDescription, "İşlem Başarılı", "Kapat");
                    setTimeout(function () {
                        window.location.reload(true);
                    }, 1000);
                }
                else {
                    SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Tekrar Dene");
                }
            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            }
        });
    }
}

// #endregion